<template>
  <svg class="decorative-divider"
       preserveAspectRatio="none"
       viewBox=" 0 0 100 100">
    <polygon :fill="fill"
             :points="points"></polygon>
  </svg>
</template>

<script>
export default {
  name: 'DecorativeDivider',
  props: {
    fill: {
      type: String,
      default: '#fff'
    },

    points: {
      type: String,
      default: '0 100 100 0 100 100'
    }
  }
}

</script>

<style lang="scss" scoped>
.decorative-divider {
  display: block;
  width: 100%;
  height: 6rem;
  z-index: 0;
}
</style>
